module.exports = __webpack_public_path__ + "img/product15.67bb5a42.png";